import { FileUploaderComponent } from '../pages/shared/file-uploader/file-uploader.component';

class UploadNotComplete {
    hasAnyEmpty: boolean;
    title: string;
}

export class FileUploadHelper {

    public static CheckUploadRequirement(fileUploaderList: FileUploaderComponent[]): UploadNotComplete {
        const filesNotUploaded: UploadNotComplete = new UploadNotComplete();
        let templateString = `Os seguintes arquivos estão pendentes: `;

        const uploadNotComplete = fileUploaderList.filter(
            uploadComponent => !uploadComponent.hasFiles()
        );

        filesNotUploaded.hasAnyEmpty = uploadNotComplete.length > 0;

        if (filesNotUploaded.hasAnyEmpty) {
            for (const upload of uploadNotComplete) {
                templateString += `${upload.investorFileType}, `;
            }

            filesNotUploaded.title = templateString;
        }

        return filesNotUploaded;
    }

}
